import React from "react";
import "./BacklogCount.css";
import Backlogbool from "./Backlogbool";
function BacklogCount(){
    

    return(
        <div>
<input type="text" autoComplete="off" name="text" class="input" placeholder="Total backlog semesters"></input>
        </div>
    );
}

export default BacklogCount;


